# Getting Started is Trivially Easy

## Two Main Tools

**LM Studio** — GUI-based, beginner-friendly, great for exploring models

**Ollama** — CLI-based, dev-friendly, perfect for workflows and automation

## Setup Time

Less than 5 minutes from download to running your first model

1. Download and install LM Studio (https://lmstudio.ai/)
2. Download Gemma 3n E4B
3. Start using it!